import { render, staticRenderFns } from "./CodeMatrix.vue?vue&type=template&id=386d8cf7&scoped=true&"
import script from "./CodeMatrix.vue?vue&type=script&lang=js&"
export * from "./CodeMatrix.vue?vue&type=script&lang=js&"
import style0 from "./CodeMatrix.vue?vue&type=style&index=0&id=386d8cf7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386d8cf7",
  null
  
)

export default component.exports